import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { getCurrentLanguage } from '@/helpers/AppHelpers';

import en from './locales/en';
import fr from './locales/fr';

Vue.use(VueI18n);

function getLocale() {
  const langEn = 'en';
  const langFr = 'fr';

  // TODO: Régler cette gestion dynamiquement
  if (isLangueDansUrl(langEn)) {
    return langEn;
  }
  if (isLangueDansUrl(langFr)) {
    return langFr;
  }

  if (isLocalDev()) {
    return getCurrentLanguage();
  }

  // Regarde si un cookie est défini
  const cookieLocale = getCookieValue('cust_xl');
  if (cookieLocale) {
    // TODO: La valeur du cookie sera surement à manipuler
    return cookieLocale;
  }
  // Sinon retourner la valeur par défaut du navigateur
  const browserLanguage = getBrowserLanguage();
  if (browserLanguage == en || browserLanguage == fr) {
    return browserLanguage;
  }
  // Si aucun language n'est trouvé
  const locale = document.querySelector('html').getAttribute('lang') === en ? en : fr;
  return locale;
}

function isLangueDansUrl(lang) {
  if (window.location.pathname.includes(`/${lang}/`)) {
    return true;
  }
  return false;
}

function getCookieValue(cookieName) {
  const cookies = document.cookie;
  if (cookies) {
    const cookiesParsed = cookies.split('; ');
    const cookie = cookiesParsed.find((el) => {
      return el.startsWith(`${cookieName.toLowerCase()}=`);
    });
    if (cookie) {
      return cookie.split('=')[1];
    }
  }
  return null;
}

function isLocalDev() {
  return window.location.href.includes('magnoliaAuthor');
}

function getBrowserLanguage() {
  let lang = window.navigator.language;
  if (lang.includes('-')) {
    lang = lang.substr(0, lang.indexOf('-'));
  }

  return lang;
}

const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: 'fr',
  messages: { en, fr },
  // Retrait warnings i18n: https://github.com/kazupon/vue-i18n/issues/201
  silentTranslationWarn: true, // process.env.NODE_ENV === "production",
});

export default i18n;
